<template>
  <div>
    <div>
      <el-input size="small" v-model="jl.name" style="width: 300px;" prefix-icon="el-icon-plus"
                placeholder="添加职称..."></el-input>
      <el-select v-model="jl.titleLevel" placeholder="职称等级" size="small"
                 style="margin-left: 5px;margin-right: 5px">
        <el-option
            v-for="item in titleLevels"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <el-button icon="el-icon-plus" type="primary" size="small" @click="addJobLevel">添加</el-button>
    </div>
    <div style="margin-top: 10px">
      <el-table
          :data="jls"
          border
          v-loading="loading"
          element-loading-text="正在加载..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          size="small"
          @selection-change="handleSelectionChange"
          style="width: 80%">
        <el-table-column
            align="center"
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            align="center"
            prop="id"
            label="编号"
            width="55">
        </el-table-column>
        <el-table-column
            align="center"
            prop="name"
            label="职称名称">
        </el-table-column>
        <el-table-column
            align="center"
            prop="titleLevel"
            label="职称级别">
        </el-table-column>
        <el-table-column
            align="center"
            prop="createDate"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            label="是否启用">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.enabled">已启用</el-tag>
            <el-tag type="danger" v-else>未启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="showEditView(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="deleteHandler(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="danger" size="small" style="margin-top: 10px" :disabled="multipleSelection.length==0"
                 @click="deleteMany">批量删除
      </el-button>

    </div>
    <el-dialog
        title="修改职称"
        :visible.sync="dialogVisible"
        width="30%">
      <div>
        <table>
          <tr>
            <td>
              <el-tag>职称名</el-tag>
            </td>
            <td>
              <el-input size="small" v-model="updateJl.name"></el-input>
            </td>
          </tr>
          <tr>
            <td>
              <el-tag>职称级别</el-tag>
            </td>
            <td>
              <el-select v-model="updateJl.titleLevel" placeholder="职称等级" size="small"
                         style="margin-left: 5px;margin-right: 5px">
                <el-option
                    v-for="item in titleLevels"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>
              <el-tag>是否启用</el-tag>
            </td>
            <td>
              <el-switch
                  v-model="updateJl.enabled"
                  active-text="启用"
                  inactive-text="禁用">
              </el-switch>
            </td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button size="small" @click="dialogVisible = false">取 消</el-button>
    <el-button size="small" type="primary" @click="doUpdate">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "JobLevelManage",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      multipleSelection: [],
      updateJl: {
        name: '',
        titleLevel: '',
        enabled: false
      },
      jl: {
        name: '',
        titleLevel: ''
      },
      jls: [],
      titleLevels: [
        '正高级',
        '副高级',
        '中级',
        '初级',
        '员级',
      ],
      url: {
        list: "/system/basic/joblevel/list",
        add: "/system/basic/joblevel/add",
        edit: "/system/basic/joblevel/edit",
        delete: "/system/basic/joblevel/delete",
        deleteList: "/system/basic/joblevel/deleteList"
      }
    }
  },
  mounted() {
    this.initJls();
  },
  methods: {
    deleteMany() {
      this.$confirm('此操作将永久删除【' + this.multipleSelection.length + '】条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = '?';
        this.multipleSelection.forEach(item => {
          ids += 'ids=' + item.id + '&';
        })
        this.deleteRequest(this.url.deleteList + ids).then(resp => {
          if (resp && resp.status) {
            this.initJls();
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    doUpdate() {
      this.putRequest(this.url.edit, this.updateJl).then(resp => {
        if (resp && resp.status) {
          this.initJls();
          this.dialogVisible = false;
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showEditView(data) {
      Object.assign(this.updateJl, data);
      this.dialogVisible = true;
    },
    deleteHandler(data) {
      this.$confirm('此操作将永久【' + data.name + '】职称, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest(this.url.delete, {"id": data.id}).then(resp => {
          if (resp && resp.status) {
            this.initJls();
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addJobLevel() {
      if (this.jl.name && this.jl.titleLevel) {

        this.postRequest(this.url.add, this.jl).then(resp => {
          if (resp && resp.status) {
            this.initJls();
          }
        });
      } else {
        this.$message.error("添加字段不可以为空!");
      }
    },
    initJls() {
      this.loading = true;
      this.getRequest(this.url.list).then(resp => {
        this.loading = false;
        if (resp && resp.status) {
          this.jls = resp.data;
          this.jl = {
            name: '',
            titleLevel: ''
          };
        }
      })
    }
  }
}
</script>

<style scoped>

</style>